<template>
<svg xmlns="http://www.w3.org/2000/svg" class="tw-fill-primary-light dark:tw-fill-primary-dark" viewBox="0 0 24 24"><path d="M7 6h16a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2m16 5H7a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2m0 7H7a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2M2 3a2 2 0 1 0 0 4 2 2 0 1 0 0-4m0 7a2 2 0 1 0 0 4 2 2 0 1 0 0-4m0 7a2 2 0 1 0 0 4 2 2 0 1 0 0-4"/></svg>
</template>
